/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartAnnotationsAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class SmartAnnotationsAPI {
		/**
		 * @function SmartAnnotationsAPI#isEnabled
		 * @description Determines whether smart annotations is enabled for the current content, regardless of the state.
		 * @returns {boolean} true if smart annotations is enabled for the content, otherwise false
		 */
		isAnnotationsEnabled() {}

		/**
		 * @function SmartAnnotationsAPI#getEnabledAnnotations
		 * @description Get the list of enabled annotations
		 * @returns {Array[Annotations]} an array of annotations that are currently enabled in the
		 * model. Will return [] if the toggle switch is off.
		 */
		getEnabledAnnotations() {}

		/**
		 * @function SmartAnnotationsAPI#hasAnnotations
		 * @description Determine whether there are annotations
		 * @returns {boolean} true iff there are annotations to show
		 */
		hasAnnotations() {}

		/**
		 * @function SmartAnnotationsAPI#getAllSuggestedAnnotations
		 * @description Execute and wait for the SA execution response to be ready
		 * @returns {Promise} resolves when the annotation execution results are ready
		 */
		getAllSuggestedAnnotations() {}

		/**
		 * @function SmartAnnotationsAPI#supportsAnnotations
		 * @description Determines whether smart annotations is supported for the current content
		 * @returns {boolean} true if smart annotations is supported for the content, otherwise false
		 */
		supportsAnnotations() {}

		/**
		 * @private
		 * @function SmartAnnotationsAPI#annotationRenderComplete
		 * @description Indicates annotations on the current content have completed rendering
		 * @returns {void}
		*/
		annotationRenderComplete() {}

		/**
		 * @private
		 * @function SmartAnnotationsAPI#annotationRenderError
		 * @description Indicates annotations on the current content have failed to render
		 * @param {Error} error The error describing the failed render
		 * @returns {void}
		 */
		annotationRenderError() {}

		/**
		 * @private
		 * @function SmartAnnotationsAPI#resetAnnotationRenderState
		 * @description Indicates a new annotation render is beginning
		 */
		resetAnnotationRenderState() {}

		/**
		 * @function SmartAnnotationsAPI#getAnnotationRenderPromise
		 * @description Provides a promise representing the latest annotation render for the
		 * current content. This is used to know that a visualization showing annotations has
		 * finished rendering, e.g. to know when it is ready to print.
		 * @return {Promise}
		 */
		getAnnotationRenderPromise() {}
	}

	return SmartAnnotationsAPI;
});
